import { Injectable } from '@angular/core';
import { CitySetEvent } from '@city/const';
import { BaseStoreFacade, CityActions } from '@city/data-access';
import { ofType } from '@ngrx/effects';
import { ActionsSubject } from '@ngrx/store';
import { EventService, createFrom } from '@spartacus/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CityEventBuilder {
  constructor(
    protected actionsSubject: ActionsSubject,
    protected eventService: EventService,
    protected baseStores: BaseStoreFacade,
  ) {
    this.registerSetCity();
  }

  protected registerSetCity(): void {
    const cityEvent$ = this.actionsSubject.pipe(
      ofType<CityActions.SetActiveBaseStore>(CityActions.SET_ACTIVE_BASE_STORE),
      map((cityAction) =>
        createFrom(CitySetEvent, {
          code: cityAction.payload,
        }),
      ),
    );

    this.eventService.register(CitySetEvent, cityEvent$);
  }
}
